var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 212836488"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    opacity: 0.26,
    cx: 22.334,
    cy: 22,
    r: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.334 11.5C28.4093 11.5 33.334 16.4247 33.334 22.5C33.334 28.5753 28.4093 33.5 22.334 33.5C16.2587 33.5 11.334 28.5753 11.334 22.5C11.334 16.4247 16.2587 11.5 22.334 11.5ZM22.334 13.7C17.4742 13.7 13.534 17.6402 13.534 22.5C13.534 27.3598 17.4742 31.3 22.334 31.3C27.1938 31.3 31.134 27.3598 31.134 22.5C31.134 17.6402 27.1938 13.7 22.334 13.7ZM26.5503 17.3707C26.811 17.1881 27.1652 17.2189 27.3896 17.4444C27.614 17.6688 27.6426 18.023 27.4589 18.2804C25.0609 21.631 23.7409 23.4262 23.5011 23.6671C22.8565 24.3106 21.8115 24.3106 21.1669 23.6671C20.5234 23.0225 20.5234 21.9775 21.1669 21.3329C21.5783 20.9226 23.3724 19.6015 26.5503 17.3707ZM28.384 21.4C28.9912 21.4 29.484 21.8928 29.484 22.5C29.484 23.1072 28.9912 23.6 28.384 23.6C27.7768 23.6 27.284 23.1072 27.284 22.5C27.284 21.8928 27.7768 21.4 28.384 21.4ZM16.284 21.4C16.8912 21.4 17.384 21.8928 17.384 22.5C17.384 23.1072 16.8912 23.6 16.284 23.6C15.6768 23.6 15.184 23.1072 15.184 22.5C15.184 21.8928 15.6768 21.4 16.284 21.4ZM18.8338 17.4444C19.2628 17.8734 19.2628 18.5697 18.8338 18.9998C18.4048 19.4288 17.7074 19.4288 17.2784 18.9998C16.8494 18.5708 16.8494 17.8734 17.2784 17.4444C17.7074 17.0154 18.4037 17.0154 18.8338 17.4444ZM22.334 15.35C22.9412 15.35 23.434 15.8428 23.434 16.45C23.434 17.0572 22.9412 17.55 22.334 17.55C21.7268 17.55 21.234 17.0572 21.234 16.45C21.234 15.8428 21.7268 15.35 22.334 15.35Z",
    fill: "#14B77C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.12b8d3b6cb7f0dcc3e52846555e83cc9.svg";
export { ForwardRef as ReactComponent };